<template>
    <popup
        v-if="data"
        class="pre-view-popup"
        fullscreen
        :active.sync="active"
        :blocked="true"
        @close="cancelHandler"
    >
        <template #header>
            <div class="close-icon">
                <vs-button
                    type="flat"
                    icon-pack="feather"
                    icon="icon-x"
                    @click="cancelHandler()"
                ></vs-button>
            </div>
        </template>
        <template #body>
            <div class="p-3 lg:p-10">
                <div class="lg:flex head mb-3 lg:mb-10 head_float">
                    <div v-if="data.job" class="subtitle-text w-full mb-2 lg:mb-0">{{ data.job.name }}</div>
                    <vs-col vs-lg="2" vs-sm="12" class="flex-1 flex justify-start lg:justify-end date-span-right" style="white-space: nowrap;">
                        <!-- <span class="lg:px-4 date-span mr-2 p-2">{{
                            item.period_time
                        }}</span> -->
                        <span class="px-4 wage p-2">{{ data.salary }} &#8376;</span>
                    </vs-col>
                </div>
                <h4 v-if="data.company" class="mb-5 block w-full text-lg lg:text-xl break-words">{{ data.company.name }}</h4>
                <!-- lg:mb-10 -->
                <div class="flex mb-3 ">
                    <div class="vals_list mb-5">
<!--                        <div class="item lg:flex items-center" v-if="data.salary">-->
<!--                            <div class="label font-semibold">{{ $t("wage") }}:</div>-->
<!--                            <div>{{ data.salary }} &#8376;</div>-->
<!--                        </div>-->
                        <div class="item lg:flex items-center" v-if="data.schedule_name">
                            <div class="label font-semibold">{{ $t("work_schedule") }}:</div>
                            <div>{{ data.schedule_name.name }}</div>
                        </div>
                        <div class="item lg:flex items-center" v-if="data.required_course">
                            <div class="label font-semibold">{{ $t("required_course") }}:</div>
                            <div>{{ data.required_course }}</div>
                        </div>
                        <!-- <div class="item lg:flex items-center">
                            <div class="label font-semibold">{{ $t("period_time") }}:</div>
                            <div>{{ data.period_time }}</div>
                        </div> -->
                        <div class="item lg:flex items-center" v-if="data.required_education_name">
                            <div class="label font-semibold">{{ $t("required_education") }}:</div>
                            <div>{{ data.required_education_name }}</div>
                        </div>
                    </div>
                </div>
                <!-- <div class="column-flex mb-3">
                    <span class="main-info">{{
                        $t("vacancy_description")
                    }}</span>
                    <span class="break-words">{{ data.vacancy_description }}</span>
                </div> -->
                <div class="column-flex mb-3" v-if="data.jodsdescription">
                    <span class="main-info">
                        {{$t("functional_responsibilities")}}
                    </span>
                    <div>
                        <div class="mr-1" v-for="(item, index) in data.jodsdescription" :key="index">
                            <span>{{ item.duties_model.name }}</span>
                        </div>
                    </div>
                </div>
                <div class="column-flex mb-3" v-if="data.requirements">
                    <span class="main-info">
                        {{$t("requirements")}}
                    </span>
                    <div class="column-flex">
                        <span>{{ data.requirements.name }}</span>
                    </div>
                </div>
                <!-- <div class="column-flex">
                    <span class="main-info">{{
                        $t("requirements")
                    }}</span>
                    <span class="break-words">{{ data.vacancy_description }}</span>
                </div> -->
            </div>
            <respond-popup
                v-bind="ChooseCVforRespond"
                @close="closeRespondPopup"
            />
        </template>
        <template #footer>
<!--            <div class="btn flex justify-end w-full p-3">-->
<!--                <vs-button type="border" @click="showSendReespondPopup()">-->
<!--                    <span>{{ $t("send_respond") }}</span>-->
<!--                </vs-button>-->
<!--            </div>-->
        </template>
    </popup>
</template>

<script>
import Popup from "./Popup.vue";
import RespondPopup from "./ChooseCVforRespond.vue";

export default {
    components: {
        Popup,
        RespondPopup,
    },
    props: {
        active: {
            type: Boolean,
        },
        title: {
            type: String,
        },
        data: {
            type: Object,
        },
    },
    data() {
        return {
            selectedImage: {
                name: "",
            },
            ChooseCVforRespond: {
                active: false,
                data: null,
            },
        };
    },
    methods: {
        // chooseImage(img){
        //     this.selectedImage = img
        // },
        // saveClickHandler (image) {
        //     this.$emit('save', { image })
        // },
        closeRespondPopup() {
            this.ChooseCVforRespond.active = false;
            this.cancelHandler();
        },
        showSendReespondPopup() {
            // this.ChooseCVforRespond.data = this.data.uid
            this.ChooseCVforRespond.vacancyUID = this.data.uid;
            this.ChooseCVforRespond.active = true;
        },
        cancelHandler() {
            this.$emit("close");
        },
    },
};
</script>

<style lang="scss" scoped>
@media only screen and (min-width: 993px) {
    .vals_list{
        .label{
            min-width: 250px;
        }
    }
}
.vals_list{
    .item{
        &:not(:last-child){
            margin-bottom: 8px;
        }
    }
}
@media only screen and (max-width: 992px) {
    .head_float{
        &::after{
            content: "";
            display: block;
            width: 100%;
            clear: both;
        }
    }
}
.vs-popup {
    width: 800px !important;
}
.subtitle-text {
    font-size: large;
    font-weight: 500;
    color: #545da7;
}
.flex-between {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.main-info {
    font-weight: bold;
    font-size: 600;
}
.column-flex {
    display: flex;
    flex-direction: column;
}
.name {
    font-size: large;
    font-weight: bold;
}
.head {
    align-items: center;
    justify-content: space-between;
}
.title-text {
    font-size: large;
    font-weight: 600;
}
.wage {
    border-radius: 30px;
    background-color: #2dcd7a;
    color: white;
    font-weight: bold;
}
.close-icon {
    display: flex;
    justify-content: flex-end;
}
.imageBox {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
}
.imageBox-active {
    border-radius: 5px;
    border: solid 1px #545da7;
    background-color: #f2f1f2;
}
</style>
